import { cn } from '@/lib/utils';
import type { VehicleFromIndexer } from '@/models/types';
import { Users } from 'lucide-react';
import { Button } from '../../ui/button';
import { SEATING_CAPACITY_OPTIONS_MAP } from './seating-capacity-selector';

export const VehicleSeatingCapacityBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleFromIndexer['seating_capacity'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  const option = SEATING_CAPACITY_OPTIONS_MAP.find(
    (option) => option.value === value?.toString(),
  );

  // Handle 0 (unset) value - display but not selectable
  const isUnset = value === 0 || value === undefined || value === null;
  const displayLabel = isUnset
    ? 'Seating capacity not set'
    : (option?.label ?? 'Unknown');

  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      <Users className="h-3 w-3" />
      {!hideCopy && (
        <p
          className={cn(
            'rounded text-xs',
            isUnset ? 'text-gray-400' : 'text-gray-600',
          )}
        >
          {displayLabel}
        </p>
      )}
    </Button>
  );
};
